<mc-dialog (closeEvent)="closeDialog(true)">
  <div class="save-changes-modal">
    <h1 class="title">Save your changes</h1>
    <p class="description">Do you want to save your changes before moving on?</p>
    <div class="apply-buttons">
      <div class="apply-buttons-link">
        <button [disabled]="saveTuningsAndAddonsChangesService.loading" (click)="discard()">Discard changes</button>
      </div>
      <div class="apply-buttons-action">
        <ng-container *permissionGuard="UserPermissions.manageSites.customizePage.saveToAll">
          @if (sitesListCount > 1) {
            <mc-button
              (click)="save(true)"
              [disabled]="saveTuningsAndAddonsChangesService.loading"
              variant="stroked"
              color="primary"
              class="apply-changes-btn apply-all"
            >
              <span class="apply-changes-btn__container">
                Save to all {{ sitesListCount }} sites
                @if (saveTuningsAndAddonsChangesService.saveButtonLoaderStatus.showLoaderSaveAll) {
                  <span class="apply-changes-btn__spinner">
                    <mc-progress-spinner></mc-progress-spinner>
                  </span>
                }
              </span>
            </mc-button>
          }
        </ng-container>
        <mc-button
          class="apply-changes-btn"
          color="primary"
          (click)="save()"
          [disabled]="saveTuningsAndAddonsChangesService.loading"
        >
          <span class="apply-changes-btn__container">
            Save
            @if (saveTuningsAndAddonsChangesService.saveButtonLoaderStatus.showLoaderSave) {
              <span class="apply-changes-btn__spinner">
                <mc-progress-spinner></mc-progress-spinner>
              </span>
            }
          </span>
        </mc-button>
      </div>
    </div>
  </div>
</mc-dialog>
